export default [
  {
    path: '/gen/list',
    name: 'genList',
    component: () => import('@/views/gen/list.vue'),
    meta: { title: '导出列表', requireAuth: true }
  }
]
